import React, { useState, useEffect } from 'react';
import tail from 'tail.select/js/tail.select.min';
import SlideToggle from "react-slide-toggle";

const Filter = (props) => {
    const [optionsState, setOptionsState] = useState({
        selected: []
    });
    /*const [orderByState, setOrderByState] = useState({
        orderBy: 'default'
    });*/
    useEffect(() => {
        let selectedCategories = [];
        props.selectedCategories.forEach(category => {
            selectedCategories.push(category._id)
        })
        setOptionsState({
            selected: selectedCategories
        })

        /*setOrderByState({
            orderBy:props.orderBy
        })*/

        let items = {};
        props.categories.forEach(category => {
            items[category._id] = {value: category.name, selected: (Object.values(selectedCategories).indexOf(category._id) > -1), group: "Select vendor"};
        })

        if(Object.keys(items).length) {
            tail("select", {
                search: true,
                descriptions: true,
                multiSelectAll: true,
                placeholder: "Select vendor",
                height: 150,
                multiContainer: ".tail-move-container",
                items: items
            })
        }

    }, [props]);

    /*const onChangeHandler = (event) => {
        let selectedOptions = [...optionsState.selected];
        let index = selectedOptions.indexOf(event.target.value)
        if(index !== -1)
            selectedOptions.splice(index,1)
        else
            selectedOptions.push(event.target.value)
        setOptionsState({
            selected: selectedOptions
        })
    }*/

    /*const handleOrderByChange = changeEvent => {
        setOrderByState({
            orderBy: changeEvent.target.value
        });
    };*/

    return (
        <div className="col-xl-3 px--xs-0">
            <SlideToggle toggleEvent={props.toggleEvent} duration={500}>
                {({ setCollapsibleElement }) => (
            <div className="search-box-outer search--field-thumb filter-tg-box" ref={setCollapsibleElement}>
                <h4 className="filter-heading">Select Filters</h4>
                <form autoComplete="off" action={`${process.env.PUBLIC_URL}/allday/category-deals`}>
                    <div className="search-fields--each">
                        <label htmlFor="" className="label-search">In</label>
                        <input type="text" placeholder="Las Vegas" className="input-search" readOnly/>
                    </div>
                    <div className="search-fields--each">
                        <label htmlFor="" className="label-search">Select Vendor</label>
                        <select readOnly value={optionsState.selected} className="select-description-02" name="categories" multiple>
                        </select>
                        <div className="tail-move-container"></div>
                    </div>
                    {/*
                    <div className="search-fields--each">
                        <label htmlFor="" className="label-search">Sort By</label>
                    </div>

                    <div className="custom-control custom-radio">
                        <input checked={orderByState.orderBy === 'default'}
                               onChange={handleOrderByChange} type="radio" id="customRadio7" name="orderby" className="custom-control-input" value="default"/>
                        <label className="custom-control-label" htmlFor="customRadio7">Default</label>
                    </div>
                    <div className="custom-control custom-radio">
                        <input checked={orderByState.orderBy === 'nearby'}
                               onChange={handleOrderByChange} type="radio" id="customRadio8" name="orderby" className="custom-control-input" value="nearby"/>
                        <label className="custom-control-label" htmlFor="customRadio8">Nearby</label>
                    </div>
                    */}

                    <div className="text-left text-xl-center mt-3 mt-xl-5">
                        <input type="submit" value="APPLY FILTERS" className="grad-on "/>
                    </div>
                </form>
            </div>
                )}
            </SlideToggle>
        </div>
    )
}

export default Filter;